import React, { useState } from 'react';
import Immutable from 'immutable';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import c from 'classnames';

import './menu-item.scss';
import './sub-menu-item.scss';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { SCREEN_TABLET } from '../../../../config/constants';
import { hideMobileMenu } from '../../../../store/actions/UI';

const SUBMENU_MAX_ITEMS_ONE_COLUMN = 6;
const SUBMENU_MAX_ITEMS_TWO_COLUMNS = 12;

const MenuItem = ({ item, path, icon, duplicate, isSubMenuItem }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [submenuIsOpen, setSubmenuIsOpen] = useState(null);
  const attrs = item.getIn(['link', 'options', 'attributes'], new Immutable.Map());
  const href = item.getIn(['link', 'url'], '');
  const expanded = item.getIn(['link', 'expanded'], false);
  const title = item.getIn(['link', 'title'], 'Untitled');
  const description = item.getIn(['link', 'description'], '');
  const subtree = item.get('subtree', new Immutable.List());
  const hasSubMenu = subtree.size !== 0 && expanded;

  return (
    <li className={c('NavigationMenu__item', { 'is-submenu-item': isSubMenuItem })}>
      <CoreLink
        to={href}
        target={attrs.get('target')}
        onClick={(e) => {
          if (width < SCREEN_TABLET && hasSubMenu && !duplicate) {
            e.preventDefault();
            setSubmenuIsOpen(!submenuIsOpen);
          } else {
            dispatch(hideMobileMenu());
            setSubmenuIsOpen(false);
          }
        }}
        className={c({
          active: item.getIn(['link', 'url']) === path,
          duplicate: duplicate,
          open: submenuIsOpen,
          closed: submenuIsOpen === false,
          'icon-after': hasSubMenu || icon,
          'icon-variant-3': hasSubMenu || icon,
          'icon-chevron': hasSubMenu && !icon,
          [`icon-${icon}`]: icon,
        })}
      >
        {duplicate ? t('all_municipalities') : `${title} ${description || ''}`}
      </CoreLink>
      {(hasSubMenu && !isSubMenuItem && !duplicate) && (
        <ul className={c('submenu', {
          open: submenuIsOpen,
          'two-columns': subtree.size > SUBMENU_MAX_ITEMS_ONE_COLUMN && subtree.size <= SUBMENU_MAX_ITEMS_TWO_COLUMNS,
          'three-columns': subtree.size > SUBMENU_MAX_ITEMS_TWO_COLUMNS,
        })}>
          {subtree.map((subItem) => {
            const subHref = subItem.getIn(['link', 'url'], '');
            const subTitle = subItem.getIn(['link', 'title'], 'Untitled');

            return (
              <MenuItem key={`menu-item-${subTitle}:${subHref}`} item={subItem} path={path} icon="arrow" isSubMenuItem />
            );
          })}
          <MenuItem key={`menu-item-${title}:${href}`} item={item} path={path} icon="arrow" duplicate />
        </ul>
      )}
    </li>
  );
};

export default MenuItem;
